export default "__VITE_ASSET__1pXF3gyJ__"